import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import Img from '@UI/Img'
import { ctrlTextLen } from '@hlj/hlj-utils'
import { dGet } from '@core/utils'
import style from './style.module.less'
import { MEAL_TAG_IMG } from '@constant'
import { CollectorsCount, Price } from '../../Common/Goods'

const hunShaLifuImgSize = {
  width: 160,
  height: 200
}

const hunPinImgSize = {
  width: 160,
  height: 160
}

const fakeStyle = {
  img: {
    backgroundColor: '#eee',
    borderRadius: 16
  },
  bottom: {
    backgroundColor: '#eee',
    width: 80,
    height: 15,
    marginTop: 15
  },
  price: {
    backgroundColor: '#eee',
    width: '100%',
    height: 15,
    marginTop: 5
  },
  title: {
    backgroundColor: '#eee',
    width: '100%',
    height: 15,
    marginTop: 15
  }
}

const Tag = inject('decorationStore')(
  observer(({ decorationStore: { themeConfig }, children }) => {
    return (
      <span
        style={{
          backgroundColor: themeConfig['blockBg'],
          color: themeConfig['blockText'] || '#fff'
        }}
        className={style.tag}
      >
        {children}
      </span>
    )
  })
)

@inject('goodsStore')
@observer
class Bottom extends Component {
  render() {
    const {
      goodsStore: { fakeMode },
      property
    } = this.props
    const isHunShaLiFu = dGet(property, 'id') == 12

    if (isHunShaLiFu) {
      const { free_trial_yarn, style_tag } = this.props
      return fakeMode ? (
        <div style={fakeStyle['bottom']} />
      ) : (
        <div>
          {free_trial_yarn == 0 ? null : <Tag>免费试纱</Tag>}
          {style_tag && <Tag>{style_tag}</Tag>}
        </div>
      )
    }

    // 婚品
    const { delivery_time, shiping } = this.props
    return fakeMode ? (
      <div style={fakeStyle['bottom']} />
    ) : (
      <div className={style.bottomTag}>
        <div>
          {shiping + '' === '0' && <Tag>包邮</Tag>}
          {delivery_time && <Tag>闪电发货</Tag>}
        </div>

        <CollectorsCount {...this.props} />
      </div>
    )
  }
}

@inject('goodsStore')
@observer
class Item extends Component {
  getImgSize = property => {
    if (dGet(property, 'id') == 12) {
      return hunShaLifuImgSize
    } else {
      return hunPinImgSize
    }
  }

  render() {
    const {
      cover_path,
      title,
      property,
      hot_tag,
      goodsStore: { fakeMode }
    } = this.props

    const imgSize = this.getImgSize(property)

    return (
      <div style={{ margin: '0 10px 20px' }}>
        {fakeMode ? (
          <div style={{ ...fakeStyle['img'], ...imgSize }} />
        ) : (
          <>
            <Img
              src={cover_path}
              style={{
                ...imgSize,
                borderRadius: 16
              }}
            />

            <img className={style.hotTag} src={MEAL_TAG_IMG[hot_tag + '']} />
          </>
        )}

        {fakeMode ? (
          <div style={fakeStyle['title']} />
        ) : (
          <div style={{ marinTop: 15 }}>{ctrlTextLen(title, 10)}</div>
        )}

        {fakeMode ? (
          <div style={fakeStyle['price']} />
        ) : (
          <div className={style.price}>
            <Price {...this.props} />
          </div>
        )}

        <Bottom {...this.props} />
      </div>
    )
  }
}

/**
 * 婚纱礼服商品
 */

export default class extends Component {
  render() {
    return (
      <div style={{ display: 'flex', flexWrap: 'wrap', margin: '0 -10px' }}>
        {(this.props.list || []).map((item, index) => (
          <Item key={item.id} index={index} {...item} />
        ))}
      </div>
    )
  }
}
